mobileSize = 1035;

function placeTixBtn() {
  if ($('body').hasClass('saffireMobileSize')) {
    $('.ticket').appendTo('.header-bottom');
  } else {
    $('.ticket').appendTo('.header-top-right');
  }
}

function placeCountdown() {
  if ($('body').hasClass('saffireMobileSize')) {
    $('#siteInfoBannerWidget').appendTo('.tier-one');
  } else {
    $('#siteInfoBannerWidget').prependTo('.header-top-left');
  }
}

function placeMascot() {
  if ($('body').hasClass('saffireMobileSize')) {
    $('.mascot').appendTo('.footer-right');
  } else {
    $('.mascot').prependTo('.footer-left');
  }
}

$.fn.isInViewport = function() {
	const elementTop = $(this).offset().top;
	const elementBottom = elementTop + $(this).outerHeight();

	const viewportTop = $(window).scrollTop();
	const viewportBottom = viewportTop + $(window).height();

	return elementBottom > viewportTop && elementTop < viewportBottom;
};

$(document).ready(function(){
  // Check Window Size
  const windowSize = $(window).width();

  if (windowSize < 1035) {
    $('body')
      .addClass('saffireMobileSize')
      .removeClass('saffireLargeSize');
  } if (windowSize > 1036) {
    $('body').removeClass('saffireMobileSize');
  }
  
  // General Message
  $('.generalmessage').prependTo('header');

  // Replace Saffire Logo
	$('.saffire_logo').attr('src', `${FULLCLIENTTHEMEPATH}images/saffire.png`);

  // Place Ticket Button
  placeTixBtn();
  
  // Place Countdown
  placeCountdown();

  // Place Mascot
  placeMascot();
});

$(window).load(function(){
	$('body').addClass('pageIsLoaded');

  // Weather Bug
  setInterval(function(){
		var str = $('#weatherBugDescription').text();
		var weatherBugSet = $('#weatherBugWidget').hasClass('weatherBugSet');
		if(!weatherBugSet && str != ''){
			$('#weatherBugWidget').addClass('weatherBugSet');
		    var findSpace = str.lastIndexOf(' ');
		    var stringLength = str.length;
		    var res = str.substring(findSpace, stringLength);
		    var start = str.substring(0, findSpace);
		    $('#weatherBugDescription').html('<span class="weatherDescriptive">'+start+'</span>'+res);
		    $('#weatherBugWidget').css('visibility', 'visible');
		}
	},12);

  // Animation
  if ($('body').hasClass('saffireLargeSize')) {
    $(window).on('load scroll', function() {
      if ($('.footer-bottom').isInViewport()) {
        $('.mascot')
          .addClass('animate__animated animate__slideInLeft')
          .css('opacity', '1');
      }
    });
  }
});

$(window).resize(function(){
  // Place Ticket Button
  placeTixBtn();

  // Place Countdown
  placeCountdown();
});